import * as THREE from "three";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import { anatomyConstants } from "../../../constants/anatomyConstants";

const SectionViewModalSimple = ({
  sectionViewModeSimple,
  setSectionViewModeSimple,
  applySectionViewSimple,
  planeOffsetSimple,
  setPlaneOffsetSimple,
  modelRefSimple,
  showHelperSimple,
  setShowHelperSimple,
  setInvertClipSimple,
  closeSectionViewModalSimple,
  isMobile,
}) => {
  const handleClick = (mode) => {
    setSectionViewModeSimple(mode);
    setPlaneOffsetSimple(0);
    applySectionViewSimple();
  };

  const handleHelperToggle = (e) => {
    e.stopPropagation();
    setShowHelperSimple((prev) => !prev);
    applySectionViewSimple();
  };

  const handleInvertToggle = (e) => {
    e.stopPropagation();
    setInvertClipSimple((prev) => !prev);
    applySectionViewSimple();
  };

  const getButtonClasses = (mode) => {
    const base =
      "w-full py-2 px-3 text-sm font-inter font-medium text-[#757575] rounded border transition focus:outline-none";
    const selected = sectionViewModeSimple === mode;

    return selected
      ? `${base} bg-gray-100 border-2 border-[var(--main-color)]`
      : `${base} bg-white border border-[#0000001A] hover:bg-gray-50`;
  };

  let sliderRangeSimple = { min: 0, max: 0, step: 0.01 };
  if (modelRefSimple && modelRefSimple.current) {
    const boundingBox = new THREE.Box3().setFromObject(modelRefSimple.current);
    const size = boundingBox.getSize(new THREE.Vector3());
    let c = 0;
    switch (sectionViewModeSimple) {
      case "xy":
        c = size.z;
        break;
      case "yz":
        c = size.x;
        break;
      case "xz":
        c = size.y;
        break;
      default:
        c = 0;
    }
    sliderRangeSimple = { min: -c / 2, max: c / 2, step: c / 100 || 0.01 };
  }

  const handleSliderChange = (e) => {
    const newOffset = Number(e.target.value);
    setPlaneOffsetSimple(newOffset);
    applySectionViewSimple();
  };

  // Check if mobile portrait (upside down) view
  const isMobilePortrait =
    isMobile &&
    typeof window !== "undefined" &&
    window.innerWidth < window.innerHeight;

  return (
    <div
      className={`absolute ${
        isMobilePortrait ? "bottom-20 left-2" : "bottom-1 left-28"
      } w-auto flex flex-col items-center z-50`}
    >
      <div
        className="flex flex-col items-start space-y-3 p-3 pt-6 bg-white rounded-lg shadow-lg border border-gray-200 w-40"
        style={{
          "--main-color": anatomyConstants.mainColor,
          "--main-color-bold": anatomyConstants.mainColorBold,
        }}
      >
        <button
          onClick={(e) => {
            e.stopPropagation();
            closeSectionViewModalSimple();
          }}
          aria-label="Close"
          className="absolute top-2 right-2 w-5 h-5 rounded-full bg-gray-100 border border-[#0000001A] shadow-sm flex items-center justify-center text-gray-700 hover:bg-gray-200 z-10"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className="w-3.5 h-3.5"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
        <button
          onClick={(e) => {
            e.stopPropagation();
            handleClick("xy");
          }}
          className={getButtonClasses("xy")}
        >
          Axial
        </button>
        <button
          onClick={(e) => {
            e.stopPropagation();
            handleClick("yz");
          }}
          className={getButtonClasses("yz")}
        >
          Sagittal
        </button>
        <button
          onClick={(e) => {
            e.stopPropagation();
            handleClick("xz");
          }}
          className={getButtonClasses("xz")}
        >
          Coronal
        </button>
        <button
          onClick={(e) => {
            e.stopPropagation();
            handleClick("none");
          }}
          className={getButtonClasses("none")}
        >
          None
        </button>

        {sectionViewModeSimple !== "none" && (
          <div className="w-full mt-2 flex items-center space-x-2">
            <input
              type="range"
              min={sliderRangeSimple.min}
              max={sliderRangeSimple.max}
              step={sliderRangeSimple.step}
              value={planeOffsetSimple}
              onChange={handleSliderChange}
              className="w-full accent-[var(--main-color)]"
            />
            <SwapHorizIcon
              onClick={handleInvertToggle}
              className="cursor-pointer text-[var(--main-color)] hover:text-[var(--main-color-bold)]"
              fontSize="small"
              titleAccess="Swap visible half"
            />
          </div>
        )}

        <button
          title="Toggle Cutting Plane"
          onClick={handleHelperToggle}
          className="w-full flex items-center space-x-2 py-2 px-3 text-sm font-medium text-white rounded bg-[var(--main-color)] hover:bg-[var(--main-color-bold)]"
        >
          {showHelperSimple ? (
            <>
              <VisibilityIcon fontSize="small" />
              <span>Hide Helper</span>
            </>
          ) : (
            <>
              <VisibilityOffIcon fontSize="small" />
              <span>Show Helper</span>
            </>
          )}
        </button>
      </div>
    </div>
  );
};

export default SectionViewModalSimple;
